import { render, staticRenderFns } from "./ipt-date.vue?vue&type=template&id=402cc453&scoped=true&"
import script from "./ipt-date.vue?vue&type=script&lang=ts&"
export * from "./ipt-date.vue?vue&type=script&lang=ts&"
import style0 from "./ipt-date.vue?vue&type=style&index=0&id=402cc453&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402cc453",
  null
  
)

export default component.exports